import { pushToDataLayer } from "@/utils/pushToDataLayer";

export const useSocialShares = (): {
  shareOnTwitter: (url: string) => void;
  shareOnFacebook: (url: string) => void;
} => {
  const shareOnTwitter = (url: string) => {
    window.open(`https://twitter.com/intent/tweet/?url=${window.location.origin}${url}`, "_blank", "popup");
    // article_interaction (share)
    pushToDataLayer({
      event: "article_interaction",
      interaction_type: "share",
      interaction_option: "twitter",
    });
  };

  const shareOnFacebook = (url: string) => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}${url}`, "_blank", "popup");
    // article_interaction (share)
    pushToDataLayer({
      event: "article_interaction",
      interaction_type: "share",
      interaction_option: "facebook",
    });
  };

  return { shareOnTwitter, shareOnFacebook };
};
